// FIXME: fix me
function isValidCode(value: string, mutipliers: number[], length: number) {
  if (!value || value.length !== length || !/^\d+$/.test(value)) {
    return false;
  }

  const digits = value
    .split('')
    .map((v) => Number(v))
    .slice(0, value.length - 2);
  let sum = 0;
  const tempMultipliers = mutipliers.slice(1, mutipliers.length);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < digits.length; i++) {
    sum += digits[i] * tempMultipliers[i];
  }

  let rest = sum % 11;
  digits.push(rest < 2 ? 0 : 11 - rest);
  sum = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < digits.length; i++) {
    sum += digits[i] * mutipliers[i];
  }

  rest = sum % 11;
  const test = rest < 2 ? 0 : 11 - rest;
  return value.endsWith(String(test));
}

export function isCnpjValid(value: string) {
  const mutipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  return isValidCode(value, mutipliers, 14);
}

export function isCpfValid(value: string) {
  const mutipliers = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
  if (/^(.)\1+$/.test(value)) {
    return false;
  }
  return isValidCode(value, mutipliers, 11);
}
